export class LocalSettings {
  /**
   * Determines which defined facility will be set if no facility is set in the context.
   */
  public facilitySelectionBehaviour: FacilitySelectionBehaviour

  /**
   * User defined facility.
   */
  public userPreferredFacility: string

  /**
   * Most recently used facility.
   */
  public lastUsedFacility: string

  public constructor(
    facilitySelectionBehaviour?: FacilitySelectionBehaviour,
    userPreferredFacility?: string,
    lastUsedFacility?: string
  ) {
    this.facilitySelectionBehaviour = facilitySelectionBehaviour
      ? facilitySelectionBehaviour
      : FacilitySelectionBehaviour.LAST_USED
    this.userPreferredFacility = userPreferredFacility
    this.lastUsedFacility = lastUsedFacility
  }

  public static EMPTY(): LocalSettings {
    return new LocalSettings()
  }
}

export enum FacilitySelectionBehaviour {
  LAST_USED = 'LAST_USED',
  USER_DEFINED = 'USER_DEFINED',
}
